// extracted by mini-css-extract-plugin
export default {"item":"basketItem_item__ixg0e","itemName":"basketItem_itemName__4KC-w","itemCount":"basketItem_itemCount__pIwNH","itemPrice":"basketItem_itemPrice__hsnWD"};